import BigNumber from "bignumber.js";

import { ChainSegmentParams } from "@/app/types";
import { PositionType } from "@/contracts/transform/position";

export const getCardInfo = ({
  amount,
  poolAddress,
  token,
  type,
  chain,
}: {
  amount: BigNumber | undefined;
  poolAddress: `0x${string}` | undefined;
  token: "base" | "quote" | undefined;
  type: PositionType | undefined;
} & ChainSegmentParams): { href: string } => {
  const isTradePosition = [PositionType.Short, PositionType.Long].includes(
    type!,
  );

  if (isTradePosition) {
    return {
      href: `/${chain}/watch-position/${poolAddress}`,
    };
  }
  if (!amount?.gt(0)) {
    return {
      href: `/${chain}/deposit/${token}:${poolAddress}`,
    };
  }

  return {
    href: `/${chain}/lend-info`,
  };
};
